module.exports = __webpack_public_path__ + "img/user-1.704b975a.svg";